import React, { useEffect, useState } from 'react';
import { useTheme, useMediaQuery, Box } from '@mui/material';
import automotiveImg from '../../assets/images/automobile.webp';
import pdfUrl from '../../assets/pdf/pdf.pdf';
import Assessment from './Assessment';

import PDFViewer from './PDFViewer';
import PPTViewer from './PPTViewer';
import VideoPlayer from './VideoPlayer';
const SecondPart = ({ fetchCourse, module, lesson, setLoader, moduleId, ct, cl, cd, loader, handleVideoEnd, questions }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [showAssessment, setShowAssessment] = useState(false);
    const styles = {
        container: {
            backgroundColor: '#f5f5f5',
            padding: isMobile ? '10px' : '20px',
            fontFamily: 'Arial, sans-serif',
            border: '1px solid #ccc',
            borderRadius: '5px',
            overflowY: "auto",
            height: isMobile ? "calc(100vh - 120px)" : "100vh",
        },
        title: {
            fontWeight: 'bold',
            marginBottom: '10px',
        },
        paragraph: {
            marginBottom: '10px',
        },
        list: {
            marginBottom: '10px',
        },
        progressBarContainer: {
            backgroundColor: '#ddd',
            borderRadius: '10px',
            marginTop: '20px',
            height: '20px',
            width: '100%',
        },
        progressBar: {
            height: '100%',
            width: '14%',
            backgroundColor: '#4caf50',
            borderRadius: '10px',
            textAlign: 'center',
            color: 'white',
            lineHeight: '20px',
        },
    };

    useEffect(() => {
        console.log("lesson", lesson);
    }, [lesson]);
    return (
        <Box sx={{ height: '100%' }}>
            <div style={styles.container}>
                {cl != null && !loader && ct === "Video" && (
                    <div className="">
                        {lesson?.videoProcessDone && lesson?.updatedUrls ? (
                            <VideoPlayer videoQualities={lesson?.updatedUrls} />
                        ) : (
                            <video
                                src={cl} // Replace with your video file URL
                                controls
                                controlsList="nodownload"
                                onEnded={handleVideoEnd}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    marginBottom: '10px',
                                }}
                                onContextMenu={(e) => e.preventDefault()} // Disable right-click menu
                            />
                        )}
                    </div>

                )}
                {cl != null && !loader && ct === "Pdf" && (

                    <PDFViewer preSignedUrl={cl} handleVideoEnd={handleVideoEnd} />
                    // <div style={{ position: 'relative', width: '100%', height: '80vh' }}>
                    //     <iframe
                    //         src={cl + "#toolbar=0"}  // Disables PDF toolbar (no download, print options)
                    //         style={{
                    //             width: '100%',
                    //             height: '100%',  // Full height of the container
                    //             position: 'absolute',
                    //         }}
                    //         title="PDF Preview"
                    //     />

                    //     {/* Transparent div overlay to prevent interactions */}
                    //     <div
                    //         style={{
                    //             position: 'absolute',
                    //             top: 0,
                    //             left: 0,
                    //             width: '100%',
                    //             height: '100%',
                    //             backgroundColor: 'transparent',
                    //             zIndex: 1,  // Make sure it sits above the iframe
                    //         }}
                    //         onContextMenu={(e) => e.preventDefault()}  // Disable right-click
                    //     />
                    // </div>

                )}
                {cl != null && !loader && ct === "PPT" && (
                    <PPTViewer
                        preSignedUrl={cl}
                        // courseId/userId would be needed for progress, passing null for now if not available in props
                        courseId={null}
                        userId={null}
                    />
                )}
                {questions?.length > 0 && !loader && ct == "assessment" && (
                    <>
                        {module?.progress?.assessment ? (
                            <>
                                {!showAssessment && (
                                    <>
                                        {/* Message for assignment submitted */}
                                        <div className="d-flex justify-content-center align-items-center flex-column">
                                            <h1>Assignment submitted</h1>

                                            {/* Re-attempt button */}
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => setShowAssessment(true)}  // Show the assessment on click
                                            >
                                                Re-attempt Assignment
                                            </button>
                                        </div>
                                    </>
                                )}

                                {/* Conditionally show assessment when the button is clicked */}
                                {showAssessment && (
                                    <div className="">
                                        <Assessment fetchCourse={fetchCourse} setShowAssessment={setShowAssessment} setLoader={setLoader} moduleId={moduleId} questions={questions} />
                                    </div>
                                )}
                            </>
                        ) : (
                            // If `module?.progress?.assessment` is false, show the assignment by default
                            <div className="">
                                <Assessment fetchCourse={fetchCourse} setShowAssessment={setShowAssessment} setLoader={setLoader} moduleId={moduleId} questions={questions} />
                            </div>
                        )}
                    </>
                )
                }
                {
                    ct != "assessment" &&
                    <div
                        className=""
                        style={{ overflowY: 'auto', maxHeight: isMobile ? 'calc(100vh - 200px)' : 'auto' }}
                        dangerouslySetInnerHTML={{ __html: cd }}
                    ></div>
                }


            </div>
        </Box>
    );
};

export default SecondPart;